import { styles as componentStyles } from './view.scss';
import { styles as commonSideMenuStyle } from '../../common/sideMenuCommon.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${commonSideMenuStyle}`),
  unsafeCSS(`${flexboxHelpersStyles}`),
  unsafeCSS(`${styleHelpers}`),
  unsafeCSS(`${textHelpersStyles}`),
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${componentStyles}`),
];
